import { Component, OnInit, Input, OnChanges, EventEmitter, Output, ViewChild } from '@angular/core';
import { Respondent } from '../model/respondent';
import { Questionnaire } from '../model/questionnaire';
import { Synchro } from '../model/synchro';
import { DataNavigationState } from '../model/data-navigation-state';
import { QuestionnaireUtil } from '../util/questionnaire-util';
import { ProjectService } from '../project/project.service';
import { ClickEvent } from '../project/pagination/pagination.component';
import { GenericModalComponent } from '../modal/generic-modal.component';
import { Json2TypescriptUtil } from '../util/json2TypescriptUtil';

@Component({
    selector: 'respondents-one-by-one',
    template: `<div class="row">
            <div *ngIf="_activeRespondent != null" class="col-md-6">
                <pagination *ngIf="_respondents != null"
                            [item-can-change]="true"
                            [indexSelectedItem]="navigationState.paginationNumber"
                            [total-nb-respondents]="_totalNumberOfRespondents"
                            (beforePageChange)="onBeforePageChange($event)"></pagination>
            </div>
        </div>
        <div class="row">
          <button class="btn btn-primary backArr" type="button" (click)="respondentList()"><span><i class="fas fa-arrow-left"></i></span>  Back To Respondent List</button>
        </div>
          <br/>
          <div class="col-md-12">
            <div *ngIf="_selectedRespondent != null" class="row">
                <respondent class="col-md-3" [respondent]="_selectedRespondent" (respondentDeleted)="onRespondentDeleted($event)" (respondentHasChanged)="onRespondentHasChange($event)" (respondentUpdated)="onRespondentUpdated($event)"></respondent>
                <dynamicData class="col-md-9" [token]="_selectedRespondent.token"></dynamicData>
            </div>
             <div class="modal" [style.display]="_questionnaireHasChanged ? 'inline' : 'none'">
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <button (click)="hideQuestionnaireHasChangedDialog()"  type="button" class="close">&times;</button>
                            <h4 class="modal-title">Juju</h4>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                        Do you want to save changes?
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" (click)="dontUpdateRespondent()">No</button>
                            <button type="button" class="btn btn-primary" (click)="updateRespondent()">Yes</button>
                        </div>
                    </div>
                </div>
        </div>
        </div>
    <generic-info-modal [hide]="_hideInfoModal" (OkClick)="onOk()"></generic-info-modal>`,
    styles:[`.backArr{margin-left: 30px;}`]
})
export class RespondentsOneByOneComponent implements OnInit, OnChanges {

     @Input('synchros')synchros: Synchro[] = null;
     @Input('navigation-state') navigationState: DataNavigationState;
     @Input('totalNbRespondents') _totalNumberOfRespondents:number;
     @Input('questionnaireID') _questionnaireId:number;
     @Input('selectedRespondent') _selectedRespondent:Respondent = null;
     @Output() backToRespondentList:EventEmitter<any> = new EventEmitter();
     @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;

    _activeRespondent: Respondent = null;
    _questionnaireUnchanged:Questionnaire = null;
    _respondents:Respondent[];
    _questionnaireHasChanged = false;
    _questionnaireIsvalid = true;
    _pageNumber = 1;
    _hideInfoModal = true;

    constructor(private _projectService: ProjectService) {
    }

    onBeforePageChange($event:ClickEvent) {
        /* if ( $event.index > 0 && $event.index <= this._respondents.length ){
            this._pageNumber = $event.index;
            if (this._questionnaireIsvalid) {
                if (!QuestionnaireUtil.isResponsesEquals(this._activeRespondent.questionnaireProject, this._questionnaireUnchanged)){
                    this._questionnaireHasChanged = true;
                }
                else{
                    this.setRespondent();
                }
            }else{
                this.setRespondent();
            }
        }*/
    }

    setRespondent() {
       /* this._activeRespondent = this._respondents[this._pageNumber - 1];
        this._questionnaireUnchanged = QuestionnaireUtil.clone(this._activeRespondent.questionnaireProject);
        this.navigationState.paginationNumber = this._pageNumber;*/
    }

    ngOnChanges() {
        // this.setRespondents();
    }

    ngOnInit() {
        // this.setRespondents();
    }

    dontUpdateRespondent() {
        // this._selectedRespondent.questionnaire = this._questionnaireUnchanged; // TODO: Uncommented because it makes no sense
        this.hideQuestionnaireHasChangedDialog();
        this.setRespondent();
    }

     hideQuestionnaireHasChangedDialog() {
        this._questionnaireHasChanged = false;
    }


   updateRespondent() {
        this._projectService.updateRespondent(this._selectedRespondent).subscribe(
        msg => {
            if(msg.valueOf() === true) {
                this.hideQuestionnaireHasChangedDialog();
                this.setRespondent();
            } else {
                    this.genericModal.defineModal('Respondent has been updated successfully!','respondent',200);
                    this._hideInfoModal=false;

            }

        });
    }

    onRespondentHasChange(questionnaireIsValid) {
        this._questionnaireIsvalid = questionnaireIsValid;
    }

    // TODO: A revoir
    onRespondentDeleted(respondent) {
        const sync = null; // this.getSynchro(respondent.synchroId);

        if (sync != null) {
          // tslint:disable-next-line:no-shadowed-variable
            const index = sync.respondents.indexOf(respondent);
            sync.respondents.splice(index, 1);
        }

        let index = this._respondents.indexOf(respondent);

        this._respondents.splice(index, 1);

        if (index ===  this._respondents.length) {
            index -= 1;
        }

        this._pageNumber = index + 1;
        this.setRespondent();
    }

    onRespondentUpdated(respondent) {
        if (this._selectedRespondent.Id === respondent.id) {
            this._projectService.getQuestionnaire(this._selectedRespondent.QuestionnaireId).subscribe(
              questionnaire => {
                  const tmp = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(questionnaire,Questionnaire);
                this._questionnaireUnchanged = QuestionnaireUtil.clone(tmp);
              },
                error => console.log(<any>error.toString())
            );
        }
    }

   // getSynchro(synchroId){
       /* let sync:Synchro = null;
        for (let synchro of this.synchros){
            if (synchro.id == synchroId){
                sync = synchro;
                break;
            }
        }
        return sync;*/
   // }

    setRespondents() {
        /*this._activeRespondent = null;

        if (this.synchros == null)
            return;

        this._respondents = [];

        for (let synchro of this.synchros) {
           this._respondents = this._respondents.concat(synchro.respondents);
        }

        if (this._respondents.length > 0) {
            if(this.navigationState.paginationNumber > 1 && this._respondents.length >= this.navigationState.paginationNumber)
                this._pageNumber = this.navigationState.paginationNumber;
            else
                this._pageNumber = 1;

            this.setRespondent();
        }*/
    }

    respondentList() {
        this.backToRespondentList.emit(this.navigationState.paginationNumber);
    }

    onOk() {
        this._hideInfoModal = true;
    }
}
